import { useQuery } from '@tanstack/react-query'

import { communityApi } from '../api/communityApi'

export const useDoneCommunitiesQuery = () =>
  useQuery({
    queryKey: ['unliving_communities'],
    queryFn: ({ signal }) => communityApi.getUnlivingCommunities({ signal }),
  })
